import { render, staticRenderFns } from "./public-blog-details.html?vue&type=template&id=641926e8&scoped=true&external"
import script from "./public-blog-details.js?vue&type=script&lang=js&external"
export * from "./public-blog-details.js?vue&type=script&lang=js&external"
import style0 from "./public-blog-details.scss?vue&type=style&index=0&id=641926e8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641926e8",
  null
  
)

export default component.exports